import React from "react";

const TariffCarImage = ({ src }: { src: string }) => (
  <img
    src={src}
    alt=""
    width={50}
    height={22}
    style={{ display: "block", objectFit: "contain" }}
  />
);

export function EconomCarIcon() {
  return <TariffCarImage src="/assets/ekonom_car.png" />;
}

export function ComfortCarIcon() {
  return <TariffCarImage src="/assets/komfort_car.png" />;
}

export function ComfortPlusCarIcon() {
  return <TariffCarImage src="/assets/komfort_plus_car.png" />;
}

export function ChevronIcon() {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M1 6L6 1L11 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EatsIcon() {
  return (
    <img
      src="/assets/eda.webp"
      alt=""
      width={24}
      height={24}
      style={{ display: "block", objectFit: "contain", borderRadius: "50%" }}
    />
  );
}

export function TimerIcon({ active }: { active: boolean }) {
  const c = active ? "var(--color-primary)" : "#FFFFFF";
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5801 5.03027C11.9646 5.03034 13.3095 5.48867 14.4043 6.33301L14.7539 6.60254L15.0645 6.28906L15.8223 5.52539C15.8873 5.4606 15.9758 5.42383 16.0684 5.42383C16.1609 5.42383 16.2495 5.46059 16.3145 5.52539C16.3794 5.59014 16.416 5.67765 16.416 5.76855C16.416 5.85855 16.3801 5.94522 16.3164 6.00977L15.5488 6.7666L15.2305 7.08008L15.5059 7.43164C16.1198 8.21379 16.5375 9.131 16.7236 10.1064C16.9097 11.0817 16.8599 12.0872 16.5771 13.0391C16.2943 13.9911 15.7869 14.8629 15.0977 15.5801C14.4084 16.2972 13.5568 16.8394 12.6143 17.1621C11.6717 17.4848 10.6649 17.5784 9.67871 17.4346C8.69261 17.2907 7.75548 16.9132 6.94531 16.335C6.13521 15.7567 5.47564 14.9941 5.02148 14.1104C4.56736 13.2267 4.3315 12.2476 4.33398 11.2549V11.2529C4.33226 9.87101 4.79627 8.52781 5.65234 7.44043L5.92969 7.08887L5.61133 6.77539L4.83496 6.00977C4.76962 5.94475 4.73276 5.85702 4.73242 5.76562C4.7321 5.67392 4.76871 5.58506 4.83398 5.51953C4.89917 5.45427 4.98802 5.41744 5.08105 5.41699C5.17442 5.41667 5.26429 5.45342 5.33008 5.51855V5.51758L6.09473 6.28906L6.40527 6.60254L6.75488 6.33301C7.84976 5.48859 9.19544 5.03027 10.5801 5.03027ZM12.7119 6.12793C11.6958 5.70836 10.5776 5.5986 9.49902 5.8125C8.42037 6.02642 7.42936 6.55448 6.65137 7.33008C5.87332 8.10577 5.34365 9.09456 5.12891 10.1709C4.91419 11.2472 5.02412 12.3632 5.44531 13.377C5.86654 14.3905 6.57955 15.257 7.49414 15.8662C8.40882 16.4755 9.48421 16.8008 10.584 16.8008C12.0588 16.8008 13.4733 16.2159 14.5166 15.1758C15.5599 14.1356 16.1465 12.7246 16.1465 11.2529C16.1464 10.1557 15.8202 9.08304 15.209 8.1709C14.5976 7.25865 13.7282 6.5476 12.7119 6.12793ZM10.584 8.38867C10.6756 8.38867 10.7628 8.42512 10.8271 8.48926C10.8914 8.55334 10.9277 8.63952 10.9277 8.72949V10.5439L11.0947 10.6924C11.2102 10.7954 11.2917 10.9314 11.3281 11.0811C11.3644 11.2305 11.3548 11.3875 11.2998 11.5312C11.2447 11.6752 11.1463 11.799 11.0186 11.8867C10.8908 11.9744 10.7394 12.0215 10.584 12.0215C10.4286 12.0215 10.2772 11.9744 10.1494 11.8867C10.0217 11.799 9.9233 11.6752 9.86816 11.5312C9.81314 11.3875 9.80356 11.2305 9.83984 11.0811C9.87628 10.9314 9.95775 10.7954 10.0732 10.6924L10.2402 10.5439V8.72949C10.2403 8.63952 10.2765 8.55334 10.3408 8.48926C10.4052 8.42511 10.4923 8.38868 10.584 8.38867ZM8.89648 2.5H12.2715C12.3631 2.5 12.4503 2.53654 12.5146 2.60059C12.5789 2.6646 12.6151 2.75096 12.6152 2.84082C12.6152 2.93082 12.5789 3.01793 12.5146 3.08203C12.4503 3.14601 12.363 3.18262 12.2715 3.18262H8.89648C8.80496 3.18261 8.71764 3.14602 8.65332 3.08203C8.58902 3.01793 8.55273 2.93082 8.55273 2.84082C8.55283 2.75095 8.58911 2.6646 8.65332 2.60059C8.70162 2.5525 8.76276 2.52001 8.8291 2.50684L8.89648 2.5Z"
        fill={c}
        stroke={c}
      />
    </svg>
  );
}

export function ExpressIcon({ active }: { active: boolean }) {
  const c = active ? "var(--color-primary)" : "#FFFFFF";
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5656 7.1229L16.3335 6.36582C16.4923 6.20742 16.5816 5.99258 16.5816 5.76857C16.5816 5.54456 16.4923 5.32972 16.3335 5.17132C16.1746 5.01292 15.9591 4.92393 15.7344 4.92393C15.5097 4.92393 15.2942 5.01292 15.1353 5.17132L14.376 5.93681C13.1935 5.02483 11.7408 4.53002 10.2458 4.53002C8.75081 4.53002 7.29812 5.02483 6.11565 5.93681L5.34783 5.16291C5.18783 5.00451 4.97127 4.91596 4.74579 4.91675C4.52031 4.91754 4.30437 5.0076 4.14549 5.16711C3.98661 5.32663 3.8978 5.54254 3.89859 5.76734C3.89938 5.99214 3.98971 6.20742 4.14971 6.36582L4.92596 7.13131C4.00038 8.30692 3.49816 9.75866 3.50002 11.2532C3.49727 12.3261 3.75185 13.3841 4.24254 14.3389C4.73323 15.2938 5.44581 16.1178 6.32084 16.7424C7.19587 17.3669 8.20799 17.7738 9.2728 17.9291C10.3376 18.0844 11.4242 17.9837 12.442 17.6353C13.4599 17.2868 14.3794 16.7009 15.1239 15.9262C15.8684 15.1515 16.4163 14.2106 16.722 13.1819C17.0277 12.1532 17.0822 11.0665 16.881 10.0125C16.6799 8.95855 16.2289 7.9678 15.5656 7.1229ZM10.25 16.3004C9.24875 16.3004 8.26997 16.0044 7.43745 15.4498C6.60492 14.8952 5.95605 14.1069 5.57288 13.1847C5.18971 12.2624 5.08946 11.2476 5.2848 10.2685C5.48013 9.28946 5.96229 8.39014 6.67029 7.68428C7.3783 6.97842 8.28035 6.49772 9.26238 6.30297C10.2444 6.10822 11.2623 6.20818 12.1874 6.59019C13.1124 6.9722 13.9031 7.61911 14.4593 8.44911C15.0156 9.27912 15.3125 10.2549 15.3125 11.2532C15.3125 12.5918 14.7792 13.8756 13.8298 14.8221C12.8803 15.7686 11.5927 16.3004 10.25 16.3004ZM8.56252 3.6824H11.9375C12.1613 3.6824 12.3759 3.59377 12.5341 3.43602C12.6924 3.27826 12.7813 3.0643 12.7813 2.8412C12.7813 2.6181 12.6924 2.40414 12.5341 2.24638C12.3759 2.08863 12.1613 2 11.9375 2H8.56252C8.33875 2 8.12413 2.08863 7.9659 2.24638C7.80767 2.40414 7.71877 2.6181 7.71877 2.8412C7.71877 3.0643 7.80767 3.27826 7.9659 3.43602C8.12413 3.59377 8.33875 3.6824 8.56252 3.6824Z"
        fill={c}
      />
      <path
        d="M8.25144 13.2857C7.94061 13.2857 7.6756 13.25 7.45642 13.1786C7.23724 13.1032 7.05791 13.0079 6.91843 12.8929C6.77896 12.7738 6.67534 12.6488 6.6076 12.5179C6.53985 12.3829 6.50399 12.254 6.5 12.131C6.5 12.0952 6.51196 12.0655 6.53587 12.0417C6.56376 12.0179 6.59564 12.006 6.63151 12.006H7.4086C7.45642 12.006 7.49428 12.0159 7.52217 12.0357C7.55007 12.0516 7.57597 12.0794 7.59988 12.119C7.63176 12.1944 7.67759 12.256 7.73737 12.3036C7.80113 12.3512 7.87685 12.3849 7.96452 12.4048C8.05219 12.4206 8.14783 12.4286 8.25144 12.4286C8.45468 12.4286 8.61209 12.3829 8.72368 12.2917C8.83924 12.1964 8.89703 12.0675 8.89703 11.9048C8.89703 11.7341 8.84323 11.6131 8.73563 11.5417C8.62803 11.4663 8.47461 11.4286 8.27535 11.4286H7.61184C7.568 11.4286 7.53214 11.4147 7.50424 11.3869C7.47634 11.3591 7.4624 11.3234 7.4624 11.2798V10.9464C7.4624 10.8988 7.47236 10.8571 7.49229 10.8214C7.51221 10.7857 7.53413 10.7599 7.55804 10.744L8.53837 9.91667H6.87659C6.83674 9.91667 6.80087 9.90278 6.76899 9.875C6.7411 9.84722 6.72715 9.81151 6.72715 9.76786V9.20833C6.72715 9.16468 6.7411 9.12897 6.76899 9.10119C6.80087 9.07341 6.83674 9.05952 6.87659 9.05952H9.6263C9.67013 9.05952 9.706 9.07341 9.73389 9.10119C9.76577 9.12897 9.78171 9.16468 9.78171 9.20833V9.71429C9.78171 9.75794 9.77175 9.79762 9.75183 9.83333C9.7319 9.86508 9.70998 9.89087 9.68607 9.91071L8.77747 10.75L8.81932 10.7619C9.04647 10.7897 9.24971 10.8512 9.42903 10.9464C9.60836 11.0377 9.74983 11.1667 9.85345 11.3333C9.95706 11.5 10.0089 11.7123 10.0089 11.9702C10.0089 12.2401 9.93115 12.4742 9.77574 12.6726C9.6243 12.8671 9.41708 13.0179 9.15406 13.125C8.89105 13.2321 8.59017 13.2857 8.25144 13.2857Z"
        fill={c}
      />
      <path
        d="M12.2755 13.2857C11.9885 13.2857 11.7395 13.246 11.5283 13.1667C11.317 13.0833 11.1417 12.9702 11.0022 12.8274C10.8667 12.6845 10.7631 12.5179 10.6914 12.3274C10.6197 12.1369 10.5778 11.9325 10.5659 11.7143C10.5619 11.6071 10.5579 11.4861 10.5539 11.3512C10.5539 11.2123 10.5539 11.0734 10.5539 10.9345C10.5579 10.7917 10.5619 10.6647 10.5659 10.5536C10.5778 10.3353 10.6197 10.1329 10.6914 9.94643C10.7671 9.75595 10.8747 9.59127 11.0142 9.45238C11.1576 9.30952 11.333 9.19841 11.5402 9.11905C11.7514 9.03968 11.9965 9 12.2755 9C12.5584 9 12.8035 9.03968 13.0107 9.11905C13.2179 9.19841 13.3913 9.30952 13.5308 9.45238C13.6742 9.59127 13.7838 9.75595 13.8595 9.94643C13.9352 10.1329 13.9771 10.3353 13.9851 10.5536C13.993 10.6647 13.997 10.7917 13.997 10.9345C14.001 11.0734 14.001 11.2123 13.997 11.3512C13.997 11.4861 13.993 11.6071 13.9851 11.7143C13.9771 11.9325 13.9352 12.1369 13.8595 12.3274C13.7878 12.5179 13.6822 12.6845 13.5427 12.8274C13.4072 12.9702 13.2339 13.0833 13.0227 13.1667C12.8154 13.246 12.5664 13.2857 12.2755 13.2857ZM12.2755 12.4226C12.4827 12.4226 12.6321 12.3571 12.7238 12.2262C12.8194 12.0913 12.8692 11.9107 12.8732 11.6845C12.8812 11.5694 12.8852 11.4484 12.8852 11.3214C12.8892 11.1944 12.8892 11.0675 12.8852 10.9405C12.8852 10.8135 12.8812 10.6964 12.8732 10.5893C12.8692 10.371 12.8194 10.1944 12.7238 10.0595C12.6321 9.9246 12.4827 9.85516 12.2755 9.85119C12.0682 9.85516 11.9188 9.9246 11.8271 10.0595C11.7355 10.1944 11.6857 10.371 11.6777 10.5893C11.6737 10.6964 11.6697 10.8135 11.6657 10.9405C11.6657 11.0675 11.6657 11.1944 11.6657 11.3214C11.6697 11.4484 11.6737 11.5694 11.6777 11.6845C11.6857 11.9107 11.7375 12.0913 11.8331 12.2262C11.9288 12.3571 12.0762 12.4226 12.2755 12.4226Z"
        fill={c}
      />
    </svg>
  );
}

export function TruckIcon({ active }: { active: boolean }) {
  const c = active ? "var(--color-primary)" : "#FFFFFF";
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.60253 5.0438H2.44922V15.2628H5.51492M9.60253 5.0438V3H13.6901L18.7996 7.08761V9.13141M9.60253 5.0438V10.1533H3.47112M15.7339 5.0438H14.712V9.13141H18.7996M18.7996 9.13141V15.2628H16.7558M12.6682 15.2628H9.60253M16.7558 14.9562C16.7558 16.085 15.8407 17 14.712 17C13.5832 17 12.6682 16.085 12.6682 14.9562C12.6682 13.8274 13.5832 12.9124 14.712 12.9124C15.8407 12.9124 16.7558 13.8274 16.7558 14.9562ZM9.60243 14.9562C9.60243 16.085 8.68739 17 7.55863 17C6.42986 17 5.51482 16.085 5.51482 14.9562C5.51482 13.8274 6.42986 12.9124 7.55863 12.9124C8.68739 12.9124 9.60243 13.8274 9.60243 14.9562Z"
        stroke={c}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CarIcon({ active }: { active: boolean }) {
  const c = active ? "var(--color-primary)" : "#FFFFFF";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.19922 9.2H3.1053M3.1053 9.2H16.8931M3.1053 9.2C3.11495 9.1554 3.12635 9.11118 3.13952 9.0675C3.17094 8.96325 3.21532 8.863 3.30456 8.66221L4.64465 5.64701C4.9096 5.05086 5.0423 4.75262 5.2517 4.53405C5.4368 4.34085 5.66384 4.19327 5.91556 4.10259C6.20034 4 6.5268 4 7.17917 4H12.819C13.4714 4 13.7981 4 14.0829 4.10259C14.3346 4.19327 14.5613 4.34085 14.7464 4.53405C14.9557 4.75247 15.0881 5.05047 15.3527 5.6458L16.6982 8.67318C16.7842 8.86668 16.828 8.96516 16.8588 9.0675C16.872 9.11118 16.8835 9.1554 16.8931 9.2M3.1053 9.2C3.0945 9.24995 3.0859 9.30038 3.07951 9.35107C3.06589 9.4591 3.06589 9.56892 3.06589 9.78864V14.4M16.8931 9.2H17.7992M16.8931 9.2C16.904 9.24995 16.9126 9.30038 16.919 9.35107C16.9326 9.45844 16.9326 9.56762 16.9326 9.78469V14.4001M16.9326 14.4001L13.4659 14.4001M16.9326 14.4001V15.2666C16.9326 16.2239 16.1565 17 15.1992 17C14.2419 17 13.4659 16.224 13.4659 15.2667V14.4001M13.4659 14.4001L6.53255 14.4M6.53255 14.4H3.06589M6.53255 14.4V15.2667C6.53255 16.224 5.75651 17 4.79922 17C3.84193 17 3.06589 16.224 3.06589 15.2667V14.4"
        stroke={c}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BikeIcon({ active }: { active: boolean }) {
  const c = active ? "var(--color-primary)" : "#FFFFFF";
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.746 6.47722L14.4168 6.14181V6.14181L13.746 6.47722ZM4.99744 12.3096L4.32662 11.9742C4.21037 12.2067 4.22279 12.4828 4.35945 12.7039C4.4961 12.925 4.7375 13.0596 4.99744 13.0596V12.3096ZM15.9913 12.645C16.1766 13.0155 16.6271 13.1656 16.9976 12.9804C17.3681 12.7952 17.5182 12.3447 17.333 11.9742L15.9913 12.645ZM10.8298 12.3096V13.0596C11.1139 13.0596 11.3736 12.8991 11.5006 12.645L10.8298 12.3096ZM13.746 4.31104C14.1602 4.31104 14.496 3.97525 14.496 3.56104C14.496 3.14682 14.1602 2.81104 13.746 2.81104V4.31104ZM12.2879 3.56104V2.81104C12.028 2.81104 11.7866 2.94562 11.6499 3.16674C11.5132 3.38785 11.5008 3.66395 11.6171 3.89645L12.2879 3.56104ZM8.64266 5.76913C9.05688 5.76913 9.39266 5.43334 9.39266 5.01913C9.39266 4.60491 9.05688 4.26913 8.64266 4.26913V5.76913ZM6.091 4.26913C5.67679 4.26913 5.341 4.60491 5.341 5.01913C5.341 5.43334 5.67679 5.76913 6.091 5.76913V4.26913ZM7.91362 6.47722V7.22722H13.746V6.47722V5.72722H7.91362V6.47722ZM7.91362 6.47722L7.2428 6.14181L4.32662 11.9742L4.99744 12.3096L5.66826 12.645L8.58444 6.81263L7.91362 6.47722ZM13.746 6.47722L13.0752 6.81263L15.9913 12.645L16.6622 12.3096L17.333 11.9742L14.4168 6.14181L13.746 6.47722ZM7.91362 6.47722L7.2428 6.81263L10.159 12.645L10.8298 12.3096L11.5006 11.9742L8.58444 6.14181L7.91362 6.47722ZM13.746 6.47722L13.0752 6.14181L10.159 11.9742L10.8298 12.3096L11.5006 12.645L14.4168 6.81263L13.746 6.47722ZM13.746 3.56104V2.81104H12.2879V3.56104V4.31104H13.746V3.56104ZM7.91362 6.47722L8.58444 6.14181L7.85539 4.68372L7.18457 5.01913L6.51375 5.35454L7.2428 6.81263L7.91362 6.47722ZM7.18457 5.01913V5.76913H8.64266V5.01913V4.26913H7.18457V5.01913ZM6.091 5.01913V5.76913H7.18457V5.01913V4.26913H6.091V5.01913ZM19.4868 12.1718H18.7368C18.7368 13.4451 17.7045 14.4774 16.4312 14.4774V15.2274V15.9774C18.533 15.9774 20.2368 14.2736 20.2368 12.1718H19.4868ZM16.4312 15.2274V14.4774C15.1579 14.4774 14.1257 13.4451 14.1257 12.1718H13.3757H12.6257C12.6257 14.2736 14.3295 15.9774 16.4312 15.9774V15.2274ZM13.3757 12.1718H14.1257C14.1257 10.8985 15.1579 9.86625 16.4312 9.86625V9.11625V8.36625C14.3295 8.36625 12.6257 10.0701 12.6257 12.1718H13.3757ZM16.4312 9.11625V9.86625C17.7045 9.86625 18.7368 10.8985 18.7368 12.1718H19.4868H20.2368C20.2368 10.0701 18.533 8.36625 16.4312 8.36625V9.11625ZM7.8201 12.2224H7.0701C7.0701 13.4957 6.03786 14.5279 4.76454 14.5279V15.2779V16.0279C6.86629 16.0279 8.5701 14.3241 8.5701 12.2224H7.8201ZM4.76454 15.2779V14.5279C3.49122 14.5279 2.45898 13.4957 2.45898 12.2224H1.70898H0.958984C0.958984 14.3241 2.66279 16.0279 4.76454 16.0279V15.2779ZM1.70898 12.2224H2.45898C2.45898 10.949 3.49122 9.91681 4.76454 9.91681V9.16681V8.41681C2.66279 8.41681 0.958984 10.1206 0.958984 12.2224H1.70898ZM4.76454 9.16681V9.91681C6.03786 9.91681 7.0701 10.949 7.0701 12.2224H7.8201H8.5701C8.5701 10.1206 6.86629 8.41681 4.76454 8.41681V9.16681ZM4.99744 12.3096V13.0596H10.8298V12.3096V11.5596H4.99744V12.3096ZM12.2879 3.56104L11.6171 3.89645L13.0752 6.81263L13.746 6.47722L14.4168 6.14181L12.9587 3.22562L12.2879 3.56104Z"
        fill={c}
      />
    </svg>
  );
}

export function KuperBagIcon({ active }: { active: boolean }) {
  return (
    <img
      src="/assets/kuper_bag.png"
      alt=""
      width={32}
      height={32}
      style={{
        display: "block",
        margin: "0 auto",
        objectFit: "contain",
        opacity: active ? 1 : 0.88,
      }}
    />
  );
}

export function YandexTaxiIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1447_47596"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path
          d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1447_47596)">
        <path
          d="M0 12H12V24H4.27333C2.78667 24 2.24667 23.8467 1.70667 23.5533C1.16728 23.2704 0.725817 22.8312 0.44 22.2933C0.16 21.7533 0 21.2133 0 19.7333V12Z"
          fill="#F2F1ED"
        />
        <path
          d="M12 12H24V19.7267C24 21.2133 23.8467 21.7533 23.5533 22.2933C23.2704 22.8327 22.8312 23.2742 22.2933 23.56C21.7533 23.8467 21.2133 24 19.7267 24H12V12Z"
          fill="black"
        />
        <path
          d="M4.27333 0H19.7267C21.2133 0 21.7533 0.153333 22.2933 0.446667C22.8327 0.729641 23.2742 1.16878 23.56 1.70667C23.8467 2.24667 24 2.78667 24 4.27333V12H0V4.27333C0 2.78667 0.153333 2.24667 0.446667 1.70667C0.729641 1.16728 1.16878 0.725817 1.70667 0.44C2.24667 0.16 2.78667 0 4.26667 0H4.27333Z"
          fill="#FFDD33"
        />
      </g>
    </svg>
  );
}

export function KuperIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5382_17429)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.87502 0H19.125C21.8169 3.75e-05 24 2.1831 24 4.87502L24 19.125C24 21.8169 21.8169 23.9999 19.125 23.9999L4.87502 24C2.18314 23.9999 7.5e-05 21.8169 7.5e-05 19.1249L0 4.87502C7.5e-05 2.1831 2.18314 3.75e-05 4.87506 3.75e-05L4.87502 0Z"
          fill="#62F77A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3625 8.2557C14.3625 8.73109 14.2176 9.17319 13.969 9.5415H16.1378C17.1912 9.5415 18.0453 10.3824 18.0453 11.4197C18.0453 12.3029 17.426 13.0438 16.5917 13.2443C16.4462 13.2793 16.2942 13.2978 16.1378 13.2978H15.6096L18.9549 17.0974H13.9263L12.0002 14.9015L10.074 17.0974H5.04541L8.39075 13.2978H7.86253C7.70613 13.2978 7.55413 13.2793 7.40867 13.2443C6.57435 13.0438 5.95512 12.3029 5.95512 11.4197C5.95512 10.3824 6.8091 9.5415 7.86253 9.5415H10.0314C9.78275 9.17319 9.63791 8.73109 9.63791 8.2557C9.63791 6.97108 10.6955 5.92969 12.0002 5.92969C13.3048 5.92969 14.3625 6.97108 14.3625 8.2557Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5847 8.25562C13.5847 8.78912 13.3128 9.26007 12.898 9.54142C12.6428 9.71458 12.3334 9.81593 12.0001 9.81593C11.6667 9.81593 11.3574 9.71458 11.1022 9.54142C10.6873 9.26007 10.4154 8.78912 10.4154 8.25562C10.4154 7.39391 11.1249 6.69531 12.0001 6.69531C12.8752 6.69531 13.5847 7.39391 13.5847 8.25562ZM13.9062 12.532H16.1377C16.7617 12.532 17.2675 12.034 17.2675 11.4196C17.2675 10.8052 16.7617 10.3072 16.1377 10.3072H7.86244C7.23849 10.3072 6.73267 10.8052 6.73267 11.4196C6.73267 12.034 7.23849 12.532 7.86244 12.532H10.094L6.74866 16.3317H9.71804L12.0001 13.7299L14.2822 16.3317H17.2515L13.9062 12.532Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5382_17429">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function YandexEdaIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="url(#pattern0_4570_18592)" />
      <defs>
        <pattern
          id="pattern0_4570_18592"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_4570_18592" transform="scale(0.00195312)" />
        </pattern>
        <image
          id="image0_4570_18592"
          width="512"
          height="512"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}

export function YandexDeliveryIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1447_48075"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path
          d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1447_48075)">
        <path d="M0 0H24V24H0V0Z" fill="#EDECEA" />
        <path
          d="M10.4769 10.8828L5.42188 14.1453V23.7678H5.45938V14.1453L10.4844 10.8828H10.4769Z"
          fill="url(#paint0_radial_1447_48075)"
        />
        <path
          d="M10.4778 10.8747L5.44531 14.1447L10.4703 10.8972V10.8672L10.4778 10.8747Z"
          fill="url(#paint1_linear_1447_48075)"
        />
        <path
          d="M13.4922 8.92586L17.9172 6.06836L13.4997 8.92586H13.4922Z"
          fill="url(#paint2_linear_1447_48075)"
        />
        <path
          d="M13.4864 8.925L17.9114 6.045C17.7164 5.67 17.4164 5.355 17.0564 5.1225L8.86641 0H7.20141C5.58891 0 4.02141 0.54 2.75391 1.545L12.9239 8.295C13.1489 8.46 13.3439 8.67 13.4864 8.9175V8.925Z"
          fill="url(#paint3_linear_1447_48075)"
        />
        <path
          d="M13.4864 8.925L17.9114 6.045C17.7164 5.67 17.4164 5.355 17.0564 5.1225L8.86641 0H7.20141C5.58891 0 4.02141 0.54 2.75391 1.545L12.9239 8.295C13.1489 8.46 13.3439 8.67 13.4864 8.9175V8.925Z"
          fill="url(#paint4_linear_1447_48075)"
        />
        <path
          d="M5.445 14.1454L10.47 10.8829C10.4035 10.7462 10.3176 10.6199 10.215 10.5079C10.1178 10.4063 10.0096 10.3158 9.8925 10.2379L0.7125 4.08789C0.243332 5.05839 -0.000245124 6.12244 1.85105e-07 7.20039V10.4029L5.4225 14.1454H5.445Z"
          fill="url(#paint5_linear_1447_48075)"
        />
        <path
          d="M5.445 14.1454L10.47 10.8829C10.4035 10.7462 10.3176 10.6199 10.215 10.5079C10.1178 10.4063 10.0096 10.3158 9.8925 10.2379L0.7125 4.08789C0.243332 5.05839 -0.000245124 6.12244 1.85105e-07 7.20039V10.4029L5.4225 14.1454H5.445Z"
          fill="url(#paint6_linear_1447_48075)"
        />
        <path
          d="M13.4922 8.92586L17.8647 6.10586L17.9247 6.06836L13.4922 8.92586Z"
          fill="url(#paint7_radial_1447_48075)"
        />
        <path
          d="M13.4922 8.92586L17.8647 6.10586L17.9247 6.06836L13.4922 8.92586Z"
          fill="url(#paint8_linear_1447_48075)"
        />
        <path
          d="M5.44438 14.1225L5.42188 14.1375L10.4769 10.875L5.44438 14.1225Z"
          fill="url(#paint9_radial_1447_48075)"
        />
        <path
          d="M5.44438 14.1225L5.42188 14.1375L10.4769 10.875L5.44438 14.1225Z"
          fill="url(#paint10_linear_1447_48075)"
        />
        <path
          d="M5.4225 14.1448L0 10.4023V16.7998C0.000475698 18.3997 0.533763 19.9538 1.51568 21.2168C2.49759 22.4798 3.8722 23.3799 5.4225 23.7748V14.1373V14.1448Z"
          fill="url(#paint11_linear_1447_48075)"
        />
        <path
          d="M5.4225 14.1448L0 10.4023V16.7998C0.000475698 18.3997 0.533763 19.9538 1.51568 21.2168C2.49759 22.4798 3.8722 23.3799 5.4225 23.7748V14.1373V14.1448Z"
          fill="url(#paint12_radial_1447_48075)"
        />
        <path
          d="M7.64813 23.9995L10.0631 22.4395L7.64062 23.9995H7.65563H7.64813Z"
          fill="url(#paint13_radial_1447_48075)"
        />
        <path
          d="M10.4781 10.8828L5.45312 14.1453V23.7753C6.02313 23.9253 6.61563 24.0003 7.20063 24.0003H7.62813L10.0581 22.4403L10.6731 22.0353V11.7528C10.6731 11.4528 10.6131 11.1528 10.4781 10.8828Z"
          fill="url(#paint14_radial_1447_48075)"
        />
        <path
          d="M10.4781 10.8828L5.45312 14.1453V23.7753C6.02313 23.9253 6.61563 24.0003 7.20063 24.0003H7.62813L10.0581 22.4403L10.6731 22.0353V11.7528C10.6731 11.4528 10.6131 11.1528 10.4781 10.8828Z"
          fill="url(#paint15_radial_1447_48075)"
        />
        <path
          d="M17.865 6.10555L13.5 8.92555C13.665 9.21055 13.755 9.53305 13.755 9.87055V20.048L17.0925 17.903C17.4419 17.6752 17.7291 17.3639 17.9281 16.9972C18.1271 16.6306 18.2318 16.2202 18.2325 15.803V7.26055C18.2325 6.84055 18.1275 6.43555 17.9325 6.06055L17.8725 6.10555H17.865Z"
          fill="url(#paint16_radial_1447_48075)"
        />
        <path
          d="M17.865 6.10555L13.5 8.92555C13.665 9.21055 13.755 9.53305 13.755 9.87055V20.048L17.0925 17.903C17.4419 17.6752 17.7291 17.3639 17.9281 16.9972C18.1271 16.6306 18.2318 16.2202 18.2325 15.803V7.26055C18.2325 6.84055 18.1275 6.43555 17.9325 6.06055L17.8725 6.10555H17.865Z"
          fill="url(#paint17_radial_1447_48075)"
        />
        <path
          d="M10.4922 10.875C10.6272 11.1525 10.7022 11.4525 10.7022 11.7525V22.05L10.7322 22.0275V11.7975C10.7322 11.475 10.6497 11.16 10.4922 10.875Z"
          fill="url(#paint18_radial_1447_48075)"
        />
        <path
          d="M10.4922 10.875C10.6272 11.1525 10.7022 11.4525 10.7022 11.7525V22.05L10.7322 22.0275V11.7975C10.7322 11.475 10.6497 11.16 10.4922 10.875Z"
          fill="url(#paint19_radial_1447_48075)"
        />
        <path
          d="M10.4922 10.875C10.6272 11.1525 10.7022 11.4525 10.7022 11.7525V22.05L10.7322 22.0275V11.7975C10.7322 11.475 10.6497 11.16 10.4922 10.875Z"
          fill="url(#paint20_radial_1447_48075)"
        />
        <path
          d="M10.4844 10.8745L13.4844 8.93945L10.4844 10.867V10.8745Z"
          fill="url(#paint21_radial_1447_48075)"
        />
        <path
          d="M10.4844 10.8745L13.4844 8.93945L10.4844 10.867V10.8745Z"
          fill="url(#paint22_radial_1447_48075)"
        />
        <path
          d="M10.4844 10.8745L13.4844 8.93945L10.4844 10.867V10.8745Z"
          fill="url(#paint23_radial_1447_48075)"
        />
        <path
          d="M10.2137 10.4851C10.1088 10.3726 9.98875 10.2676 9.86125 10.1851L0.71875 4.08008L9.89875 10.2076C10.0112 10.2901 10.1237 10.3801 10.2137 10.4851Z"
          fill="url(#paint24_linear_1447_48075)"
        />
        <path
          d="M10.2137 10.4851C10.1088 10.3726 9.98875 10.2676 9.86125 10.1851L0.71875 4.08008L9.89875 10.2076C10.0112 10.2901 10.1237 10.3801 10.2137 10.4851Z"
          fill="url(#paint25_linear_1447_48075)"
        />
        <path
          d="M10.2137 10.4851C10.1088 10.3726 9.98875 10.2676 9.86125 10.1851L0.71875 4.08008L9.89875 10.2076C10.0112 10.2901 10.1237 10.3801 10.2137 10.4851Z"
          fill="url(#paint26_radial_1447_48075)"
        />
        <path
          d="M13.4639 8.92492H13.4864C13.3439 8.68492 13.1564 8.47492 12.9239 8.30242L2.75391 1.54492L12.8939 8.29492C13.1189 8.45992 13.3214 8.67742 13.4639 8.93242V8.92492Z"
          fill="url(#paint27_linear_1447_48075)"
        />
        <path
          d="M13.4639 8.92492H13.4864C13.3439 8.68492 13.1564 8.47492 12.9239 8.30242L2.75391 1.54492L12.8939 8.29492C13.1189 8.45992 13.3214 8.67742 13.4639 8.93242V8.92492Z"
          fill="url(#paint28_linear_1447_48075)"
        />
        <path
          d="M13.4639 8.92492H13.4864C13.3439 8.68492 13.1564 8.47492 12.9239 8.30242L2.75391 1.54492L12.8939 8.29492C13.1189 8.45992 13.3214 8.67742 13.4639 8.93242V8.92492Z"
          fill="url(#paint29_radial_1447_48075)"
        />
        <path
          d="M10.2138 10.4846C10.3188 10.5971 10.4088 10.7246 10.4838 10.8596L13.4838 8.93211C13.3338 8.67711 13.1463 8.45961 12.9138 8.28711L2.75125 1.53711C1.88765 2.22048 1.19232 3.09285 0.71875 4.08711L9.85375 10.1921C9.98875 10.2746 10.1088 10.3796 10.2138 10.4921V10.4846Z"
          fill="url(#paint30_linear_1447_48075)"
        />
        <path
          d="M10.2138 10.4846C10.3188 10.5971 10.4088 10.7246 10.4838 10.8596L13.4838 8.93211C13.3338 8.67711 13.1463 8.45961 12.9138 8.28711L2.75125 1.53711C1.88765 2.22048 1.19232 3.09285 0.71875 4.08711L9.85375 10.1921C9.98875 10.2746 10.1088 10.3796 10.2138 10.4921V10.4846Z"
          fill="url(#paint31_radial_1447_48075)"
        />
        <path
          d="M10.2138 10.4846C10.3188 10.5971 10.4088 10.7246 10.4838 10.8596L13.4838 8.93211C13.3338 8.67711 13.1463 8.45961 12.9138 8.28711L2.75125 1.53711C1.88765 2.22048 1.19232 3.09285 0.71875 4.08711L9.85375 10.1921C9.98875 10.2746 10.1088 10.3796 10.2138 10.4921V10.4846Z"
          fill="url(#paint32_linear_1447_48075)"
        />
        <path
          d="M10.2138 10.4846C10.3188 10.5971 10.4088 10.7246 10.4838 10.8596L13.4838 8.93211C13.3338 8.67711 13.1463 8.45961 12.9138 8.28711L2.75125 1.53711C1.88765 2.22048 1.19232 3.09285 0.71875 4.08711L9.85375 10.1921C9.98875 10.2746 10.1088 10.3796 10.2138 10.4921V10.4846Z"
          fill="url(#paint33_radial_1447_48075)"
        />
        <path
          d="M10.4844 10.8748L13.4619 8.94727L10.4844 10.8673V10.8748Z"
          fill="url(#paint34_radial_1447_48075)"
        />
        <path
          d="M10.4844 10.8748L13.4619 8.94727L10.4844 10.8673V10.8748Z"
          fill="url(#paint35_radial_1447_48075)"
        />
        <path
          d="M10.4844 10.8748L13.4619 8.94727L10.4844 10.8673V10.8748Z"
          fill="url(#paint36_linear_1447_48075)"
        />
        <path
          d="M10.4844 10.8748L13.4619 8.94727L10.4844 10.8673V10.8748Z"
          fill="url(#paint37_radial_1447_48075)"
        />
        <path
          d="M13.4988 8.92578H13.4688C13.6262 9.21078 13.7088 9.53328 13.7163 9.85578V20.0558L13.7463 20.0333V9.85578C13.7463 9.53328 13.6563 9.21078 13.4913 8.93328L13.4988 8.92578Z"
          fill="url(#paint38_radial_1447_48075)"
        />
        <path
          d="M13.4988 8.92578H13.4688C13.6262 9.21078 13.7088 9.53328 13.7163 9.85578V20.0558L13.7463 20.0333V9.85578C13.7463 9.53328 13.6563 9.21078 13.4913 8.93328L13.4988 8.92578Z"
          fill="url(#paint39_radial_1447_48075)"
        />
        <path
          d="M13.4988 8.92578H13.4688C13.6262 9.21078 13.7088 9.53328 13.7163 9.85578V20.0558L13.7463 20.0333V9.85578C13.7463 9.53328 13.6563 9.21078 13.4913 8.93328L13.4988 8.92578Z"
          fill="url(#paint40_radial_1447_48075)"
        />
        <path
          d="M13.4697 8.94727L10.4922 10.8748C10.6422 11.1598 10.7172 11.4748 10.7172 11.7973V22.0123L13.7172 20.0773V9.85477C13.7172 9.53977 13.6272 9.22477 13.4697 8.95477V8.94727Z"
          fill="url(#paint41_radial_1447_48075)"
        />
        <path
          d="M13.4697 8.94727L10.4922 10.8748C10.6422 11.1598 10.7172 11.4748 10.7172 11.7973V22.0123L13.7172 20.0773V9.85477C13.7172 9.53977 13.6272 9.22477 13.4697 8.95477V8.94727Z"
          fill="url(#paint42_radial_1447_48075)"
        />
        <path
          d="M13.4697 8.94727L10.4922 10.8748C10.6422 11.1598 10.7172 11.4748 10.7172 11.7973V22.0123L13.7172 20.0773V9.85477C13.7172 9.53977 13.6272 9.22477 13.4697 8.95477V8.94727Z"
          fill="url(#paint43_radial_1447_48075)"
        />
        <path
          d="M13.4697 8.94727L10.4922 10.8748C10.6422 11.1598 10.7172 11.4748 10.7172 11.7973V22.0123L13.7172 20.0773V9.85477C13.7172 9.53977 13.6272 9.22477 13.4697 8.95477V8.94727Z"
          fill="url(#paint44_radial_1447_48075)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07312 20.2878) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_1447_48075"
          x1="6.97531"
          y1="-0.982813"
          x2="7.85281"
          y2="11.0022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1447_48075"
          x1="15.0447"
          y1="-1.57414"
          x2="15.9147"
          y2="10.4184"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1447_48075"
          x1="9.96891"
          y1="-1.2075"
          x2="10.8464"
          y2="10.785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEBCD" />
          <stop offset="1" stopColor="#FCD08F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1447_48075"
          x1="9.96891"
          y1="-1.2075"
          x2="10.8464"
          y2="10.785"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1447_48075"
          x1="4.4025"
          y1="-0.80211"
          x2="5.2725"
          y2="11.1979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEBCD" />
          <stop offset="1" stopColor="#FCD08F" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1447_48075"
          x1="4.4025"
          y1="-0.79461"
          x2="5.2725"
          y2="11.1979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07281 20.2884) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_1447_48075"
          x1="15.0447"
          y1="-1.57414"
          x2="15.9222"
          y2="10.4184"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <radialGradient
          id="paint9_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07313 20.2875) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <linearGradient
          id="paint10_linear_1447_48075"
          x1="6.96688"
          y1="-0.982503"
          x2="7.83688"
          y2="11.0025"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_1447_48075"
          x1="4.7325"
          y1="18.8848"
          x2="-5.8425"
          y2="9.39734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CF9B57" />
          <stop offset="1" stopColor="#FFD28D" />
        </linearGradient>
        <radialGradient
          id="paint12_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.034 23.1237) rotate(-128.37) scale(13.8356 12.8048)"
        >
          <stop stopColor="#CA8D32" />
          <stop offset="1" stopColor="#F2C888" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.98562 21.1795) rotate(-27.4056) scale(16.201 14.6408)"
        >
          <stop stopColor="#C4892F" />
          <stop offset="1" stopColor="#E6BE81" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07187 20.2878) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.98812 21.1803) rotate(-27.4056) scale(16.201 14.6408)"
        >
          <stop stopColor="#C4892F" />
          <stop offset="1" stopColor="#E6BE81" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.0725 20.288) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.9875 21.1805) rotate(-27.4056) scale(16.201 14.6408)"
        >
          <stop stopColor="#C4892F" />
          <stop offset="1" stopColor="#E6BE81" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(13.5598 -8.66182 7.82787 12.2542 -1.07285 20.2875)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(10.9202 13.937 -10.4069 8.1542 1.55966 0.3675)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.68" stopColor="#FFF1DC" />
          <stop offset="1" stopColor="#F1D2A4" />
        </radialGradient>
        <radialGradient
          id="paint20_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(14.3829 -7.45714 6.73894 12.9976 4.98717 21.18)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4892F" />
          <stop offset="1" stopColor="#E6BE81" />
        </radialGradient>
        <radialGradient
          id="paint21_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07313 20.2869) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.55937 0.359456) rotate(51.9207) scale(17.7056 13.221)"
        >
          <stop stopColor="white" />
          <stop offset="0.68" stopColor="#FFF1DC" />
          <stop offset="1" stopColor="#F1D2A4" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.14256 -0.493836) rotate(46.91) scale(15.8854 11.8617)"
        >
          <stop stopColor="#FFF6E8" />
          <stop offset="0.68" stopColor="#FFF9EF" />
          <stop offset="1" stopColor="#F0DBBC" />
        </radialGradient>
        <linearGradient
          id="paint24_linear_1447_48075"
          x1="4.87375"
          y1="-0.832422"
          x2="5.74375"
          y2="11.1601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEBCD" />
          <stop offset="1" stopColor="#FCD08F" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_1447_48075"
          x1="4.87375"
          y1="-0.832422"
          x2="5.74375"
          y2="11.1601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <radialGradient
          id="paint26_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.14318 -0.493214) rotate(46.91) scale(15.8854 11.8617)"
        >
          <stop stopColor="#FFF6E8" />
          <stop offset="0.68" stopColor="#FFF9EF" />
          <stop offset="1" stopColor="#F0DBBC" />
        </radialGradient>
        <linearGradient
          id="paint27_linear_1447_48075"
          x1="7.66641"
          y1="-1.03508"
          x2="8.53641"
          y2="10.9574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEBCD" />
          <stop offset="1" stopColor="#FCD08F" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_1447_48075"
          x1="7.66641"
          y1="-1.03508"
          x2="8.53641"
          y2="10.9574"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <radialGradient
          id="paint29_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.14053 -0.49337) rotate(46.91) scale(15.8854 11.8617)"
        >
          <stop stopColor="#FFF6E8" />
          <stop offset="0.68" stopColor="#FFF9EF" />
          <stop offset="1" stopColor="#F0DBBC" />
        </radialGradient>
        <linearGradient
          id="paint30_linear_1447_48075"
          x1="6.54625"
          y1="-0.95289"
          x2="7.41625"
          y2="11.0321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFEBCD" />
          <stop offset="1" stopColor="#FCD08F" />
        </linearGradient>
        <radialGradient
          id="paint31_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.55875 0.35961) rotate(51.9207) scale(17.7056 13.221)"
        >
          <stop stopColor="white" />
          <stop offset="0.68" stopColor="#FFF1DC" />
          <stop offset="1" stopColor="#F1D2A4" />
        </radialGradient>
        <linearGradient
          id="paint32_linear_1447_48075"
          x1="6.54625"
          y1="-0.95289"
          x2="7.41625"
          y2="11.0321"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <radialGradient
          id="paint33_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.14318 -0.493682) rotate(46.91) scale(15.8855 11.8617)"
        >
          <stop stopColor="#FFF6E8" />
          <stop offset="0.68" stopColor="#FFF9EF" />
          <stop offset="1" stopColor="#F0DBBC" />
        </radialGradient>
        <radialGradient
          id="paint34_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07313 20.2873) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <radialGradient
          id="paint35_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.55937 0.359767) rotate(51.9207) scale(17.7056 13.221)"
        >
          <stop stopColor="white" />
          <stop offset="0.68" stopColor="#FFF1DC" />
          <stop offset="1" stopColor="#F1D2A4" />
        </radialGradient>
        <linearGradient
          id="paint36_linear_1447_48075"
          x1="11.1594"
          y1="-1.29023"
          x2="12.0369"
          y2="10.7023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2" />
          <stop offset="1" stopColor="#E3B673" />
        </linearGradient>
        <radialGradient
          id="paint37_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.14256 -0.493524) rotate(46.91) scale(15.8855 11.8617)"
        >
          <stop stopColor="#FFF6E8" />
          <stop offset="0.68" stopColor="#FFF9EF" />
          <stop offset="1" stopColor="#F0DBBC" />
        </radialGradient>
        <radialGradient
          id="paint38_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07376 20.2883) rotate(-32.5684) scale(16.0902 14.5411)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <radialGradient
          id="paint39_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.98935 21.1853) rotate(-27.41) scale(16.2011 14.6408)"
        >
          <stop stopColor="#C4892F" />
          <stop offset="1" stopColor="#E6BE81" />
        </radialGradient>
        <radialGradient
          id="paint40_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.14626 -0.494219) rotate(46.91) scale(15.8854 11.8617)"
        >
          <stop stopColor="#FFF6E8" />
          <stop offset="0.68" stopColor="#FFF9EF" />
          <stop offset="1" stopColor="#F0DBBC" />
        </radialGradient>
        <radialGradient
          id="paint41_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.07281 20.2873) rotate(-32.57) scale(16.0902 14.541)"
        >
          <stop stopColor="#CB9440" />
          <stop offset="1" stopColor="#FFD38F" />
        </radialGradient>
        <radialGradient
          id="paint42_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.55969 0.359766) rotate(51.9207) scale(17.7056 13.221)"
        >
          <stop stopColor="white" />
          <stop offset="0.68" stopColor="#FFF1DC" />
          <stop offset="1" stopColor="#F1D2A4" />
        </radialGradient>
        <radialGradient
          id="paint43_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.98719 21.1798) rotate(-27.4056) scale(16.201 14.6408)"
        >
          <stop stopColor="#C4892F" />
          <stop offset="1" stopColor="#E6BE81" />
        </radialGradient>
        <radialGradient
          id="paint44_radial_1447_48075"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-2.14225 -0.493526) rotate(46.91) scale(15.8855 11.8617)"
        >
          <stop stopColor="#FFF6E8" />
          <stop offset="0.68" stopColor="#FFF9EF" />
          <stop offset="1" stopColor="#F0DBBC" />
        </radialGradient>
      </defs>
    </svg>
  );
}
